export const DEFAULT_BIRD_AVATAR = '';
